// 中国象棋's board content (boards.js draws it): the pieces' characters and the river's words. Game content, the same in
// every language (tools/i18n-allow.txt), as on a real board.
export const XQ_CHARS = { K: '帅', A: '仕', B: '相', N: '马', R: '车', C: '炮', P: '兵', k: '将', a: '士', b: '象', n: '马', r: '车', c: '砲', p: '卒' };
/** The river's two halves, left and right as red sees the board. */
export const RIVER = ['楚 河', '汉 界'];
